import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sites: null,
  selectedSite: null,
  savedSite: null,
  saveSiteSuccess: false,
  sharedSiteInfo: {
    success: [],
    details: [],
    farmerName: "",
  },
  shareSiteSuccess: false,
  crops: [],
  seeds: [],
  tillages: [],
};

const siteSlice = createSlice({
  name: "site",
  initialState,
  reducers: {
    setSites: (state, action) => {
      state.sites = action.payload;
    },
    setSelectedSite: (state, action) => {
      state.selectedSite = action.payload;
    },
    setSavedSite: (state, action) => {
      state.savedSite = action.payload;
    },
    setSaveSiteSuccess: (state, action) => {
      state.saveSiteSuccess = action.payload;
    },
    setSharedSiteInfo: (state, action) => {
      state.sharedSiteInfo.success = action.payload.success;
      state.sharedSiteInfo.details = action.payload.details;
      state.sharedSiteInfo.farmerName = action.payload.farmerName;
    },
    setShareSiteSuccess: (state, action) => {
      state.shareSiteSuccess = action.payload;
    },
    setCropOptions: (state, action) => {
      state.crops = action.payload.crops;
      state.seeds = action.payload.seeds;
      state.tillages = action.payload.tillages;
    },
  },
});

export const {
  setSites,
  setSelectedSite,
  setSavedSite,
  setSaveSiteSuccess,
  setSharedSiteInfo,
  setShareSiteSuccess,
  setCropOptions,
} = siteSlice.actions;
export default siteSlice.reducer;
